import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

export const Message = styled.span`
  margin-inline-end: 8px;

  color: #ffffff;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 16px;
`;

export const Email = styled.span`
  color: #4585ff;
`;
